function TrackConditionController(CommonService, userViewService, $window, config, $scope, $sce) {
  const ctrl = this;

  ctrl.$onInit = () => {
    userViewService.setView('track-condition');
    $scope.trackConditionURL = $sce.trustAsResourceUrl(config.trackConditionURL);
  }

  ctrl.redirectToLogin = () => {
    $window.open(config.trackConditionURL, '_blank');

    /* 
     * In case of possible autologin, refresh smartvision page to reload iframe 
     * after ALB session cookie has been received
    */ 
    setTimeout(function () { 
      $window.location.reload(); 
    }, 5000);
  };
}

angular
  .module('track-condition.module')
  .controller('TrackConditionController', TrackConditionController);
